/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { RegisterUserProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "RegisterPageService";
const log: any = LoggerModule.getInstance();

export class RegisterPageService {
  private static instance: RegisterPageService;
  private vapp: VApplication;
  private readonly loginRestAPI: string;
  private readonly headers: any;
  private readonly signerPK: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.signerPK = props.signerPK;
  }

  public static getInstance(props: any = {}): RegisterPageService {
    if (!RegisterPageService.instance) {
      RegisterPageService.instance = new RegisterPageService(props);
    }
    return RegisterPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async registerUser(args: RegisterUserProps) {
    let _args = {
      ...args,
      apiURL: this.loginRestAPI,
      headers: this.headers,
    };
    const agent = getAgent();
    return agent.registerUser(_args);
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;

    const agent = getAgent();
    const { token, decoded } = await agent?.parseAndDecodeToken({
      signerPK: this.signerPK,
    });
    content = {
      ...content,
      initialData: {
        email: decoded?.email,
        firstName: decoded?.firstName,
        lastName: decoded?.lastName,
      },
      token: token,
      isPassword: decoded?.authType === "PASSWORD",
    };
    return content;
  }
}
